module.exports = __webpack_public_path__ + "media/images/bitmap/main-image-2-e55b89e53d982246dc51a926fc0181f7.png";